/* eslint-disable no-eval */

export default {
  loadScript() {
    const script = document.createElement('script');
    script.src = 'https://js.iugu.com/v2';
    script.type = 'text/javascript';

    if (!window.Iugu) {
      document.body.appendChild(script);
    }

    script.addEventListener('load', () => {
      const { Iugu } = window;
      Iugu.setAccountID(process.env.VUE_APP_IUGU_ACCOUNT_ID);

      if (
        process.env.NODE_ENV === 'development' ||
        process.env.NODE_ENV === 'staging'
      ) {
        Iugu.setTestMode(true);
      }
    });
  },
};
